export class Login_pObj {
    pinNumber: number;
    emailId: string;
}
